// export const NextConfigHeaders = [
// 	{
// 		source: '/(.*)',
// 		headers: [
// 			{
// 				key: 'Referrer-Policy',
// 				value: 'strict-origin-when-cross-origin',
// 			},
// 			{
// 				key: 'Permissions-Policy',
// 				value: 'camera=(), microphone=(), geolocation=()',
// 			},
// 			{
// 				key: 'Strict-Transport-Security',
// 				value: 'max-age=31536000; includeSubDomains; preload',
// 			},
// 			{
// 				key: 'X-Frame-Options',
// 				value: 'SAMEORIGIN',
// 			},
// 			{
// 				key: 'Service-Worker-Allowed',
// 				value: '/',
// 			},
// 			{
// 				key: 'X-Content-Type-Options',
// 				value: 'nosniff',
// 			},
// 			{
// 				key: 'X-DNS-Prefetch-Control',
// 				value: 'on',
// 			},
// 			{
// 				key: 'X-XSS-Protection',
// 				value: '1; mode=block',
// 			},
// 			{
// 				key: 'Cross-Origin-Opener-Policy',
// 				value: 'same-origin',
// 			},
// 			{
// 				key: 'Cross-Origin-Resource-Policy',
// 				value: 'same-site',
// 			},
// 		],
// 	},
// ];

export const NextConfigHeaders = [
	{
		source: '/(.*)',
		headers: [
			{
				key: 'Referrer-Policy',
				value: 'strict-origin-when-cross-origin'
			},
			{
				key: 'Permissions-Policy',
				value: 'camera=(), microphone=(), geolocation=()'
			},
			{
				key: 'Strict-Transport-Security',
				value: 'max-age=31536000; includeSubDomains; preload'
			},
			{
				key: 'X-Frame-Options',
				value: 'SAMEORIGIN'
			},
			{
				key: 'X-Content-Type-Options',
				value: 'nosniff'
			},
			{
				key: 'X-DNS-Prefetch-Control',
				value: 'on'
			},
			{
				key: 'X-XSS-Protection',
				value: '1; mode=block'
			}
		]
	}
]
